/* WEARTH PDP motion below ATC — play when in view, HTTPS-safe */
(function () {
  "use strict";

  function toHttps(url) {
    if (!url) return url;
    var u = String(url).trim();
    if (u.indexOf("//") === 0) return "https:" + u;
    if (u.indexOf("http://") === 0) return "https://" + u.slice(7);
    return u;
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function hydrateVideo(video) {
    if (!video || video.getAttribute("data-wearth-src-ready") === "1") return;
    video.querySelectorAll("source").forEach(function (s) {
      var raw = s.getAttribute("src") || s.getAttribute("data-src") || "";
      if (!raw) return;
      s.src = toHttps(raw);
      s.removeAttribute("data-src");
    });
    var direct = video.getAttribute("src");
    if (direct) video.setAttribute("src", toHttps(direct));
    video.setAttribute("data-wearth-src-ready", "1");
    try {
      video.load();
    } catch (_) {}
  }

  function markPlaying(video, root) {
    if (!video) return;
    video.classList.add("wearth-pdp-motion--playing");
    if (root) root.classList.add("wearth-pdp-motion--active");
    try {
      video.removeAttribute("poster");
    } catch (_) {}
  }

  function playVideo(video, root) {
    if (!video) return;
    video.muted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    hydrateVideo(video);
    try {
      var p = video.play();
      if (p && typeof p.then === "function") {
        p.then(function () {
          markPlaying(video, root);
        }).catch(function () {});
      }
    } catch (_) {}
  }

  function pauseVideo(video, root) {
    if (!video) return;
    try {
      video.pause();
    } catch (_) {}
    video.classList.remove("wearth-pdp-motion--playing");
    if (root) root.classList.remove("wearth-pdp-motion--active");
  }

  function readPayload(root) {
    var sid = root.getAttribute("data-section-id");
    if (!sid) return { default: "", videos: {} };
    var el = document.getElementById("wearth-pdp-motion-data-" + sid);
    if (!el) return { default: "", videos: {} };
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (_) {
      return { default: "", videos: {} };
    }
  }

  function setColor(root, video, payload, color) {
    var videos = payload.videos || {};
    var url = videos[color];
    if (!url) return;
    pauseVideo(video, root);
    var src = video.querySelector("source");
    if (src) src.src = toHttps(url);
    else video.src = toHttps(url);
    video.setAttribute("data-wearth-src-ready", "0");
    playVideo(video, root);
  }

  function bindColorPickers(root, video, payload) {
    var scope = root.closest("[data-section]") || root.closest(".product") || document;
    scope.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var n = (input.name || "").toLowerCase();
      if (n.indexOf("color") < 0 && n.indexOf("colour") < 0) return;
      input.addEventListener("change", function () {
        if (input.checked) setColor(root, video, payload, input.value);
      });
    });
    scope.querySelectorAll("select").forEach(function (sel) {
      var n = (sel.name || "").toLowerCase();
      if (n.indexOf("color") < 0 && n.indexOf("colour") < 0) return;
      sel.addEventListener("change", function () {
        setColor(root, video, payload, sel.value);
      });
    });
  }

  function observeInView(root, video) {
    if (!("IntersectionObserver" in window)) {
      playVideo(video, root);
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.2) {
            playVideo(video, root);
          } else {
            pauseVideo(video, root);
          }
        });
      },
      { threshold: [0, 0.2, 0.45], rootMargin: "0px 0px 80px 0px" }
    );
    obs.observe(video);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) pauseVideo(video, root);
      else if (video.getBoundingClientRect().top < window.innerHeight) playVideo(video, root);
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute("data-wearth-pdp-motion-init") === "1") return;
    root.setAttribute("data-wearth-pdp-motion-init", "1");
    var video = root.querySelector("[data-wearth-pdp-motion-video]");
    if (!video) return;

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    var payload = readPayload(root);
    bindColorPickers(root, video, payload);

    video.addEventListener("playing", function () {
      markPlaying(video, root);
    });
    video.addEventListener("loadeddata", function () {
      if (!video.paused) markPlaying(video, root);
    });

    hydrateVideo(video);
    observeInView(root, video);

    if (payload.default && payload.videos && payload.videos[payload.default]) {
      /* src already set server-side; ensure play once visible */
    }
  }

  ready(function () {
    document.querySelectorAll("[data-wearth-pdp-motion]").forEach(initRoot);
  });
})();
